import type { TranslationTag } from '@ps/web-core-intl';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import LoadingIndicator from '@swf/components/LoadingIndicator/LoadingIndicator';

import { TXTWCL_WeXre_working_on_this } from './FirstLoader.messages.json';
import { loading } from './FirstLoader.scss';

interface Props {
  label?: TranslationTag;
}

const FirstLoader: React.FC<Props> = ({ label = TXTWCL_WeXre_working_on_this }) => (
  <div className={loading}>
    <LoadingIndicator variant="poker" loading />
    <Translation tagName="span" {...label} />
  </div>
);

export default FirstLoader;
